import { supabase } from "@/shared/lib/supabase";
import { sentryUtils } from "@/shared/utils/sentry";

interface EstateDetails {
  estateId: number;
  dob?: string;
  dod?: string;
  relationship?: string;
}

export async function saveEstateDetails({
  estateId,
  dob,
  dod,
  relationship,
}: EstateDetails): Promise<void> {
  const estateUpdate: Record<string, string> = {};
  if (dob) estateUpdate.date_of_birth = dob;
  if (dod) estateUpdate.date_of_death = dod;

  if (Object.keys(estateUpdate).length > 0) {
    await supabase.from("estates").update(estateUpdate).eq("estate_id", estateId);
  }

  if (relationship) {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return;

    const { data: userData } = await supabase
      .from("users")
      .select("user_id")
      .eq("auth_id", user.id)
      .single();

    if (!userData) return;

    await supabase
      .from("user_estates")
      .update({ relationship_to_decedent: relationship })
      .eq("user_id", userData.user_id)
      .eq("estate_id", estateId);
  }
}

export async function saveEstateDetailsSafe(details: EstateDetails): Promise<void> {
  try {
    await saveEstateDetails(details);
  } catch (err) {
    sentryUtils.captureError(err, "Estate details save failed");
  }
}
